// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3PWr_","rootCenter":"LoadMoreObserver_rootCenter__39lUq","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2LO38"};